/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightDownIcon64Regular = forwardRef('ArrowDUturnRightDownIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M44 28.5C44 17.73 35.27 9 24.5 9S5 17.73 5 28.5v15a1.5 1.5 0 0 0 3 0v-15C8 19.387 15.387 12 24.5 12S41 19.387 41 28.5v21.502a2.514 2.514 0 0 1-.363-.334L26.617 34a1.5 1.5 0 1 0-2.235 2l14.02 15.669a5.5 5.5 0 0 0 8.197 0L60.618 36a1.5 1.5 0 0 0-2.236-2L44.363 49.668a2.514 2.514 0 0 1-.363.334V28.5Z" })));
});
